<div class="tag-container d-flex w-100">
    <!-- Pill Tags -->
    <div class="pill-list w-auto d-flex align-items-center">
        <zui-pill-content *ngFor="let tag of tags" class="pill" data-uit="custom-tag">
            <span [caTruncate]="truncateLimit">{{ tag }}</span>
            <zui-interactive-icon emphasis="subtle" slot="iconClose" aria-label="Remove Tag" (click)="onCloseTag(tag)">
                <zui-icon-symbols-close size="s8"></zui-icon-symbols-close>
            </zui-interactive-icon>
        </zui-pill-content>
    </div>

    <!-- Input Field -->
    <div class="tag-input w-100">
        <ca-med-tag-studyid-input-field
            class="w-100"
            (createTag)="addTag($event)"
            [tags]="tags"
            [isFilesPage]="isFilesPage"
            [name]="'newTag'"
            [placeholder]="placeholder"
            [titleKey]="titleKey"
        ></ca-med-tag-studyid-input-field>
    </div>
</div>
